import { render, staticRenderFns } from "./ManageInstitutions.vue?vue&type=template&id=106d360e&scoped=true&"
import script from "./ManageInstitutions.vue?vue&type=script&lang=js&"
export * from "./ManageInstitutions.vue?vue&type=script&lang=js&"
import style0 from "./ManageInstitutions.vue?vue&type=style&index=0&id=106d360e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d360e",
  null
  
)

export default component.exports